// Service-config registry for Post a Project (Atrium Stage 7).
//
// SERVICE_CONFIGS is a { [key]: config } map keyed by the JobPosting boolean
// column. The writing-group agent owns this assembly; each group exports its own
// group-map (CONFIG-SCHEMA §0) and we spread the three so there is no merge race.

import { WRITING_CONFIGS } from "./writing"
import { DESIGN_MEDIA_CONFIGS } from "./designMedia"
import { ENHANCE_TEXT_CONFIGS } from "./enhanceText"

export const SERVICE_CONFIGS = {
  ...WRITING_CONFIGS,
  ...DESIGN_MEDIA_CONFIGS,
  ...ENHANCE_TEXT_CONFIGS,
}
